<template>
  <div class="Complaints">
    <van-image class="Complaints-img" :src="img" />
    <div class="Complaints-box">
      <div class="Complaints-box-Content">
        <i class="iconfont f-size-20">&#xe625;</i>
        <span class="f-size-14"
          >在这里您可以为我们点赞、吐槽、提问、建议，我们讲及时回复，您的留言，是我们前进的动力。</span
        >
      </div>
    </div>
    <div class="ComplaintsContent">
      <div class="ComplaintsContent-top">
        <i class="iconfont">&#xe61f;</i>
        <span>历史留言</span>
        <div class="ComplaintsContent-topRight" v-touch:tap="message()">
          写留言
        </div>
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div
          class="ComplaintsContent-box"
          v-for="(item, index) in messages"
          :key="item.id"
          :class="
            index === messages.length - 1 ? 'ComplaintsContent-box-last' : ''
          ">
          <div class="ComplaintsContent-boxTop">
            <van-image
              class="boxTop-img"
              v-bind:src="userImg"
              style="float: left"
              radius="50%" />
            <!-- v-bind:src="item.img" -->
            <div class="ComplaintsContent-boxTop-left ellipsis">
              {{ item.name }}
            </div>
            <div class="ComplaintsContent-boxTop-right">{{ item.time }}</div>
          </div>
          <div class="ComplaintsContent-boxText" v-if="item.reply">
            {{ item.content }}
          </div>
          <div
            class="ComplaintsContent-boxText ComplaintsContent-boxText-two"
            v-else>
            {{ item.content }}
          </div>
          <div class="ComplaintsContent-boxName" v-if="item.reply">
            馆方回复：
          </div>
          <div class="ComplaintsContent-boxNamtext" v-if="item.reply">
            {{ item.reply }}
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import http from "@js/http-ww.js";
import { List } from "vant";
import { getAllMessageUrl } from "@culturalRelicsUrl";
import { Toast } from "vant";
import util from "@util";
export default {
  data() {
    return {
      img: require("../../lib/image/complaint/45.png"),
      userImg: require("@image/personalCenter/chanegImage/111.png"),
      messages: [
        {
          id: 1,
          img: require("../../lib/image/complaint/Oval5.png"),
          name: "海博最美",
          time: "2019-11-20  09:30",
          content:
            "以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、品香为核心元素的中国传统文化空间。让人们慢下来、坐下来品品香，修身养性。",
          reply: "感谢您的支持，海南博物院欢迎您！",
        },
        {
          id: 2,
          img: require("../../lib/image/complaint/Oval58.png"),
          name: "海博最美",
          time: "2019-11-20  09:30",
          content:
            "以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、品香为核心元素的中国传统文化空间。让人们慢下来、坐下来品品香，修身养性。",
          reply: "感谢您的支持，海南博物院欢迎您！",
        },
        {
          id: 3,
          img: require("../../lib/image/complaint/Oval9.png"),
          name: "海博最美",
          time: "2019-11-20  09:30",
          content:
            "以中国传统沉香文化为基点，营造出一个以古代家具、书画、古琴、品香为核心元素的中国传统文化空间。让人们慢下来、坐下来品品香，修身养性。",
          reply: "感谢您的支持，海南博物院欢迎您！",
        },
      ],
      //分页
      loading: false,
      finished: false,
      requestParams: {
        pageNum: -1,
        pageSize: 20,
      },
    };
  },
  created() {
    this.messages = [];
  },
  methods: {
    //跳转留言编写
    message() {
      return () => {
        this.$router.push({ path: "messageBoard", query: {} }).catch((err) => {
          err;
        });
        // this.$toast("暂不能留言，下次再来哦...");
      };
    },
    //获取文物列表
    getAllMessageList() {
      this.requestParams.pageNum++;
      http
        .get(getAllMessageUrl, {
          params: { ...this.requestParams },
          loading: false,
        })
        .then((res) => {
          const { data: array = [] } = res.data;
          this.loading = false;

          array.map((item) => {
            this.messages.push({
              categoriesId: item.AntiqueCategoryID,
              time: util.formatTime(
                new Date(item.creationDate),
                "yyyy.MM.dd hh:mm"
              ),
              img: item.creatorAvatarSmall,
              name: item.username || "游客",
              content: item.text,
              reply: item.replyText,
            });
          });

          this.loading = false;
          if (array.length === 0) {
            this.finished = true;
          }
        })
        .catch((error) => {
          this.finished = true;
        });
    },

    onLoad() {
      this.getAllMessageList();
    },
  },
  components: {
    [List.name]: List,
    [Toast.name]: Toast,
  },
};
</script>
<style lang="less" scoped>
.Complaints {
  background: #eff0fa !important;
  .Complaints-img {
    height: 236px;
    width: 100%;
  }
  .Complaints-box {
    position: relative;
    top: -18px;
    padding: 0 10px;
    .Complaints-box-Content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 8px 0px rgba(212, 206, 218, 0.5);
      border-radius: 5px;
      padding: 20px;
      color: #727980;
      .f-size-20 {
        font-size: 20px;
      }
      .f-size-14 {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
  .ComplaintsContent {
    padding: 0 7px;
    .ComplaintsContent-top {
      position: relative;
      margin-bottom: 20px;
      i {
        color: #5a9bf6;
        font-size: 20px;
        padding-left: 10px;
      }
      span {
        color: #606060;
        font-size: 14px;
        line-height: 20px;
        padding-left: 10px;
      }
      .ComplaintsContent-topRight {
        background: url(../../lib/image/complaint/yuan.png) left no-repeat;
        background-size: 40px 40px;
        height: 40px;
        line-height: 40px;
        padding-left: 50px;
        position: absolute;
        top: -9px;
        right: 10px;
        color: #3388ff;
        font-size: 14px;
      }
    }
    .ComplaintsContent-box {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 8px 0px rgba(212, 206, 218, 0.5);
      border-radius: 10px;
      padding: 20px;
      margin-bottom: 16px;
      .ComplaintsContent-boxTop {
        overflow: auto;
        zoom: 1;
        .boxTop-img {
          width: 50px;
          height: 50px;
          overflow: visible !important;
        }
        .ComplaintsContent-boxTop-left {
          float: left;
          color: #3388ff;
          font-size: 14px;
          font-weight: 500;
          padding: 5px 0 0 10px;
          max-width: 40%;
        }
        .ComplaintsContent-boxTop-right {
          float: right;
          color: #9ca3b1;
          font-size: 14px;
          font-weight: 400;
          padding-top: 5px;
        }
      }
      .ComplaintsContent-boxText {
        padding: 10px 0;
        color: #7d838f;
        font-size: 12px;
      }
      .ComplaintsContent-boxText-two {
        padding-bottom: 0 !important;
      }
      .ComplaintsContent-boxName {
        color: #585e6a;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        padding-top: 10px;
        border-top: 1px dashed #b0bbd2;
      }
      .ComplaintsContent-boxNamtext {
        padding-top: 12px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(125, 131, 143, 1);
        line-height: 18px;
      }
    }
    .ComplaintsContent-box-last {
      margin: 0;
    }
  }
}
</style>
